<template>
  <div class="products-cluna">
    <v-container>
      <v-row>
        <v-col cols="3">
          <div class="sub-categories-cluna" style="background-color: white">
            <div class="title-sub-categories-cluna">
              <span style="color: white">{{ oracle.translate('دسته بندی ها') }}</span>
            </div>
            <ul v-if="!IsTrue" :style="isEN? 'padding-left: 20px !important;' : 'padding-right: 20px !important;'">
              <li
                  class="item-sub-categories-cluna"
                  v-for="(itemcat, index) in AllCat"
                  :key="index">
                <span class="font-weight-bold" style="font-size: 15px !important;">{{
                    oracle.category_name(itemcat)
                  }}</span>
                <ul>
                  <li
                      v-for="(item, index) in itemcat.subcat"
                      :key="index"
                      v-ripple role="button" @click="getProductAll(item)">
                    <a class="mrx-1">{{ oracle.category_name(item) }}
                      <i :class="isEN ? 'mdi-chevron-right' : 'mdi-chevron-left'" class="mdi"
                         style="color: #7dc353"></i></a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </v-col>
        <v-col cols="9">
          <div class="show-products-cluna">
            <div class="titles-show-products-cluna">
              <span style="color: white">{{ isEN ? '' : oracle.translate('محصولات') }} <b>{{ CatName }}</b> </span>
            </div>
            <div class="list-show-products-cluna">
              <div v-if="empty">
                <v-col cols="12" id="bg-products-cluna">
                  <div class="bg-products-cluna">
                    <img alt="" src="../assets/image/banner.jpg"/>
                  </div>
                </v-col>
              </div>
              <div class="items-show-products-cluna" v-else>
                <div
                    class="itemproduct-cluna"
                    v-for="(item, index) in productCat"
                    :key="index">
                  <div class="add-to-cart-cluna"></div>
                  <router-link role="button"
                               :to="{ name: 'single', query: { id: item.product_id } }"
                               style="display: flex;flex-wrap: wrap;justify-content: center;">
                    <div>
                      <div class="img-itemproduct-cluna mb-2">
                        <img class="mrx-auto mlx-auto" alt="" :src="item.product_icon"/>
                      </div>
                      <div class="text-itemproduct-cluna">
                        <h6 style="text-align: center !important;" class="multi-line text-center">
                          {{ oracle.product_title(item) }}</h6>
                        <span style="font-size: 14px;text-align: center !important;"
                              class="font-weight-bold text-center">{{
                            oracle.format(item.product_sell_price)
                          }} {{ oracle.translate('تومان') }}</span>
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import oracle from "@/oracle";

export default {
  name: "products",
  data: () => ({
    dataProducts: [{id: "0", count: 0}],
    page: 1,
    oracle: oracle,
    empty: false,
    IsTrue: false,
    initBase: false,
    isEN: oracle.isEN(),
    productCat: [],
    AllCat: [],
    CatName: "",
  }),
  methods: {
    plus(id) {
      this.dataProducts.forEach((item) => {
        if (item.id === id) item.count += 1;
      });
    },
    minus(id) {
      this.dataProducts.forEach((item) => {
        if (item.id === id) item.count -= 1;
      });
    },
    GetCatProducts(response) {
      this.productCat = response.data;
    },
    GetCat(response) {
      for (let i = 0; i < response.data.length; i++) {
        response.data[i].subcat = [];
      }
      this.AllCat = response.data;
      for (let i = 0; i < this.AllCat.length; i++) {
        oracle.axios(
            "productCategory/getList",
            {
              offset_by: 0,
              limit_by: 1000,
              order_by: "priority",
              parent_by: this.AllCat[i].category_id,
            },
            this.GetSubCat,
            null,
            null,
            this.AllCat[i]
        );
      }
    },
    GetSubCat(response, category) {
      category.subcat = response.data;
      this.IsTrue = true;
      this.IsTrue = false;
      if (!this.initBase) {
        for (let i = 0; i < response.data.length; i++) {
          let sub = response.data[i]
          if (this.$route.query.idcat != null) {
            if (sub.category_id == this.$route.query.idcat) {
              this.initBase = true
              this.getProductAll(sub)
            }
          } else {
            this.initBase = true
            this.getProductAll(sub)
          }
        }
      }
    },
    getProductAll(cat) {
      this.$router.push({query: {idcat: cat.category_id}})
      this.CatName = oracle.category_name(cat)
      oracle.axios(
          "product/getList",
          {
            offset_by: 0,
            limit_by: 1000,
            order_by: "priority",
            parent_by: cat.category_id,
          },
          this.GetCatProducts
      );
      document.getElementById('app').scrollIntoView({behavior: 'smooth'});
    },
  },
  mounted() {
    this.CatName = this.$route.query.namecat;
    oracle.axios(
        "productCategory/getList",
        {offset_by: 0, limit_by: 1000, order_by: "priority"},
        this.GetCat
    );
  },
};
</script>
<style>
.products-cluna {
  background: #fff;
}

.products-cluna .sub-categories-cluna {
  min-height: 450px;
  border: 2px solid #7ec352;
  border-radius: 3px;
}

.products-cluna .title-sub-categories-cluna {
  color: #fff;
  line-height: 40px;
  padding: 0 10px;
  font-size: 15px;
  background-color: #7ec352;
}

.products-cluna .sub-categories-cluna ul {
  display: flex;
  padding: 15px;
  font-size: 12px;
  margin: 0;
  flex-direction: column;
}

.products-cluna .item-sub-categories-cluna {
  padding-bottom: 10px;
}

.products-cluna .item-sub-categories-cluna span {
  font-size: 14px;
}

.products-cluna .item-sub-categories-cluna ul {
  padding-right: 15px;
  padding-left: 15px;
}

.products-cluna .item-sub-categories-cluna ul li {
  padding-right: 15px;
  padding-left: 15px;
  line-height: 30px;
  position: relative;
  transition: color ease 0.2s;
}

.products-cluna .item-sub-categories-cluna > ul li:before {
  content: "•";
  color: #7ec352;
  position: absolute;
  right: 0;
  font-size: 25px;
  line-height: 0;
  top: 16px;
}

.dir-ltr .products-cluna .item-sub-categories-cluna > ul li:before {
  content: "•";
  color: #7ec352;
  position: absolute;
  left: 0;
  font-size: 25px;
  line-height: 0;
  top: 16px;
}

.products-cluna .item-sub-categories-cluna ul li a {
  color: #333;
}

.products-cluna .show-products-cluna {
  width: 100%;
  min-height: 400px;
}

.products-cluna .titles-show-products-cluna {
  background-color: #7ec352;
  color: #fff;
  line-height: 40px;
  padding: 0 10px;
  font-size: 15px;
  border-radius: 3px 3px 0 0;
  border: 2px solid #7ec352;
  border-bottom: 0;
}

.products-cluna .bg-products-cluna {
  width: 100%;
  height: 500px;
}

.products-cluna .bg-products-cluna img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background-color: #fff;
}

#bg-products-cluna {
  padding: 0;
}

.products-cluna .itemproduct-cluna {
  position: relative;
  text-align: center !important;
  width: 160px;
  /*margin: auto;*/
  margin-top: 30px;
  flex: 0 0 21%;
  display: flex;
}

.products-cluna .img-itemproduct-cluna {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  overflow: hidden;
}

.products-cluna .img-itemproduct-cluna img {
  width: 100%;
  height: 100%;
}

.products-cluna .text-itemproduct-cluna {
  display: flex;
  flex-direction: column;
}

.products-cluna .items-show-products-cluna {
  display: flex;
  flex-wrap: wrap;
}

.products-cluna .items-show-products-cluna a {
  color: #333;
}

.products-cluna .text-itemproduct-cluna h6 {
  font-size: 13px;
  margin-top: 8px;
}

.products-cluna .text-itemproduct-cluna span {
  font-size: 12px;
  color: #7ec352;
  margin-top: 5px;
}

.products-cluna .add-to-cart-cluna {
  position: absolute;
  top: 5px;
  left: 10px;
}

.products-cluna .add-to-cart-cluna ul {
  display: flex;
  border: 2px solid #7ec352;
  background: #fff;
  border-radius: 25px;
  justify-content: space-between;
  padding: 0 3px !important;
}

.products-cluna .add-to-cart-cluna ul li .v-icon {
  color: #7ec352;
  font-size: 18px !important;
}

.products-cluna .add-to-cart-cluna ul li:nth-child(2) {
  padding: 0 5px;
}

.products-cluna .footer-show-products-cluna {
  margin: 20px 0;
}
</style>
